import React from "react";
import { Button } from "antd";
import empyImg from "../../../images/insights/emptystate.svg";
import RenderComponent from "../../General/RenderComponent";

function InsightsError({ show, setRerun = () => { } }) {
    return (
        <RenderComponent
            show={show}
            emptyProps={{
                image: empyImg,
                className: "oi-empty report--insights--details--error",
                description: (
                    <div className="report--insights--details--error--cont">
                        <span className="report--insights--details--error--desc1">Oops!</span>
                        <span className="report--insights--details--error--desc2">
                            It seems that no data was found. Please click the button below to refresh and generate the required data.
                        </span>
                    </div>
                ),
                extra: <Button type="primary" onClick={() => { setRerun(true); }}>Reload</Button>
            }}
        />
    );
}

export default InsightsError;
